import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/native-builds/native-builds.component').then(
        m => m.NativeBuildsComponent,
      ),
  },
];
